/**
 * reCAPTCHA Enterprise Account Defender Action Names
 * 
 * These action names are used for Account Defender's site-specific model
 * to detect suspicious behavior patterns over time.
 * 
 * Reference: https://cloud.google.com/recaptcha/docs/account-defender#report-actions
 */

export const RECAPTCHA_ACTIONS = {
  // Authentication actions
  LOGIN: 'LOGIN',
  REGISTRATION: 'REGISTRATION',
  
  // Account management actions
  ACCOUNT_UPDATE: 'ACCOUNT_UPDATE',
  PASSWORD_RESET: 'PASSWORD_RESET',
  SECURITY_QUESTION_CHANGE: 'SECURITY_QUESTION_CHANGE',
  PHONE_NUMBER_UPDATE: 'PHONE_NUMBER_UPDATE',
  EMAIL_UPDATE: 'EMAIL_UPDATE',
  
  // Payment actions
  LIST_PAYMENT_METHODS: 'LIST_PAYMENT_METHODS',
  PAYMENT_TRANSACTION: 'PAYMENT_TRANSACTION',
  
  // MFA and security
  TRIGGER_MFA: 'TRIGGER_MFA',
  
  // Promotional actions
  REDEEM_CODE: 'REDEEM_CODE',
};

export default RECAPTCHA_ACTIONS;

